export const STOCK_REPORT_GO_BUTTON_API = 'STOCK_REPORT_GO_BUTTON_API'
export const STOCK_REPORT_GO_BUTTON_API_SUCCESS = 'STOCK_REPORT_GO_BUTTON_API_SUCCESS'

//*************** */ Stock Report 1 ***************************
export const STOCK_PROCESSING_ACTION = 'STOCK_PROCESSING_ACTION'
export const STOCK_PROCESSING_API_SUCCESS = 'STOCK_PROCESSING_API_SUCCESS'

export const STOCK_REPORT_1_GO_BUTTON_API = 'STOCK_REPORT_1_GO_BUTTON_API'
export const STOCK_REPORT_1_GO_BUTTON_API_SUCCESS = 'STOCK_REPORT_1_GO_BUTTON_API_SUCCESS'

export const STOCK_REPORT_API_ERROR_ACTION = 'STOCK_REPORT_API_ERROR_ACTION'